import CircularProgress from '@mui/material/CircularProgress'

export const Spinner = ({ color = '#ffffff', size = 30, margin = '' }) => {
    const spinnerStyles = {
        width: `${size}px`,
        height: `${size}px`,
        color,
        margin,
    }

    return <CircularProgress style={spinnerStyles} color="inherit" />
}
